import axios from "axios";
import { DateTime } from "luxon";

export const media = (id) => `https://gg-loyalty-media.s3-us-west-2.amazonaws.com/${id}`;

export async function addToCart(code, items, checkout) {
  window.parent.postMessage({
    ggl: true,
    topic: "ADD",
    code: code,
    checkout: checkout,
    items: items,
  }, "*");
}

// check conditions
export function checkConditions(conditions = [], context) {
  return conditions.every(x => {
    if(x === 'BIRTHDAY') {
      if(!context.birthday) {
        return false;
      }
      let dT = DateTime.local().setZone('Pacific/Auckland').toFormat('LL dd');
      let dB = DateTime.fromISO(context.birthday).setZone('Pacific/Auckland').toFormat('LL dd');
      return(dT === dB);
    }
    if(x === 'BIRTHDAY_MONTH') {
      if(!context.birthday) {
        return false;
      }
      let dT = DateTime.local().setZone('Pacific/Auckland').toFormat('LL');
      let dB = DateTime.fromISO(context.birthday).setZone('Pacific/Auckland').toFormat('LL');
      return(dT === dB);
    }
    let parts = x.split(' ');
    if(parts.length === 3) { // check it's the right format, should be an attribute, comparator, and value. e.g. Attr == Value
      switch (parts[1]) {
        case 'INCLUDES':
          return context[parts[0]].includes(parts[2]);
        case 'EXCLUDES':
          return !context[parts[0]].includes(parts[2]);
        case '==':
          return context[parts[0]] === parts[2];
        case '!=':
          return context[parts[0]] !== parts[2];
        case '>=':
          return +context[parts[0]] >= +parts[2];
        case '<=':
          return +context[parts[0]] <= +parts[2];
        case '>':
          return +context[parts[0]] > +parts[2];
        case '<':
          return +context[parts[0]] < +parts[2];
        default:
          console.log('invalid condition', parts);
          return false;
      }
    } else { // if it's not in the right format, it might be something we don't want to evaluate...
      return false;
    }
  });
}

const swipeConfidenceThreshold = 10000;
const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};

export const onDragEnd = (offset, velocity, onLeft = () => {}, onRight = () => {}) => {
  const swipe = swipePower(offset.x, velocity.x);
  if (swipe < -swipeConfidenceThreshold) {
    onRight();
  } else if (swipe > swipeConfidenceThreshold) {
    onLeft();
  }
}

// takes the old and new conditions, and returns our goal data.
export const getGoal = (oldConditions = [], newConditions = []) => {
  let oldArr = oldConditions.reduce((result, obj) => {
    let newResult = [ ...result ];
    let parts = obj.split(' ');
    if(parts.length === 3 && !isNaN(parts[2])) {
      newResult.push([parts[0], parts[2]]);
    }
    return newResult;
  }, []);
  let goal = newConditions.reduce((result, obj) => {
    let parts = obj.split(' ');
    if(parts.length === 3 && (parts[1] === '>' || parts[1] === '>=' || parts[1] === '==') && !isNaN(parts[2])) {
      let oIndex = oldArr.findIndex(x => (x[0] === parts[0] && x[1] !== parts[2]));
      return {
        field: parts[0],
        oldTarget: (oIndex !== -1) ? +oldArr[oIndex][1] : 0,
        newTarget: +parts[2]
      }
    } else {
      return result;
    }
  }, null);
  return goal;
}

export async function finishAccount(dob, id) {
  let result = await GQL(`
    mutation {
      enableAccount(id: "${id}") {
        accountEnabled
      }
      setBirthday(id: "${id}", date: "${dob}") {
        points
        lifetimePoints
        referral
        lifetimeSpend
        lifetimeOrders
        birthday
        accountEnabled
        tiers
      }
    }
  `);
  let setBirthday = result && result.data && result.data.data && result.data.data.setBirthday;
  let enableAccount = result && result.data && result.data.data && result.data.data.enableAccount;
  if(setBirthday && enableAccount) {

    window.parent.postMessage({
      ggl: true,
      topic: "ENABLED",
    }, "*");

    return setBirthday;
  }
}

export async function redeemReward(id, rewardId) {
  let result = await GQL(`
    mutation {
      redeemReward(id: "${id}", rewardId: "${rewardId}") {
        code
        error
      }
    }
  `);
  let data = result && result.data && result.data.data && result.data.data.redeemReward;
  if(data && data.code) {
    return data.code;
  } else if (data && data.error) {
    console.log(data.error);
  }
}

export async function getActivity(id) {
  let result = await GQL(`
    {
      getCustomerTransactions(id: "${id}") {
        created
        points
        reason
        type
        details
      }
    }
  `);
  let data = result && result.data && result.data.data && result.data.data.getCustomerTransactions;
  if(data && data.length) {
    return data;
  }
}

export async function GQL(query = '') {
  // const urlParams = new URLSearchParams(window.location.search);
  // let hmac = urlParams.get("hmac");
  // urlParams.delete("hmac");
  // urlParams.sort();
  return await axios({
    url: `https://tqq5smklnbe3fjh2ypmry3lpga.appsync-api.us-west-2.amazonaws.com/graphql`,
    method: 'post',
    headers: {
      'Content-Type' : 'application/json',
      'x-api-key' : 'da2-3jrcen4zo5biflptjg7akdqpe4',
      'ks-shop-context' : 'good-george-brewing.myshopify.com',
      'ks-shop-hash' : '3463071dc41b2b547b91690f6370bb8b28d0c689dde6b46720f33513b9b69d2d'
    },
    data: {
      query: query
    }
  });
}

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};
